import React from "react";
import MMC_Phone_App_Home from "./svg/MMC_Phone App_Home-2.svg";

interface HomeIconProps {
  onClick: () => void;
}

const HomeIcon: React.FC<HomeIconProps> = ({ onClick }) => {
  return (
    <button className="app-icon" onClick={onClick}>
      <img src={MMC_Phone_App_Home} alt="Home Icon" />
    </button>
  );
};

export default HomeIcon;
